import script from "./MyChartBook.vue?vue&type=script&setup=true&lang=js"
export * from "./MyChartBook.vue?vue&type=script&setup=true&lang=js"

import "./MyChartBook.vue?vue&type=style&index=0&id=605a4642&lang=scss"

const __exports__ = script;

export default __exports__